import React from "react";
import Slider from "react-slick";
import { FaLinkedin } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import member01 from "../../assets/team/member01.jpg";
import member2 from "../../assets/team/member2.png";
import member3 from "../../assets/team/member3.jpeg";
import member4 from "../../assets/team/member4.jpeg";
import member5 from "../../assets/team/member5.jpg";
import member6 from "../../assets/team/member6.jpeg";
import member7 from "../../assets/team/member7.jpeg";
import member8 from "../../assets/team/member8.jpeg";
import member9 from "../../assets/team/member9.jpg";
//import member02 from "../../assets/team/member02.jpg";
import images from "../../assets/team/images.jpg";

import "./Team.css";

/* =========================
   Team Member Card
========================= */
const TeamMember = ({ name, designation, image, linkedin }) => (
  <article className="team-member" aria-label={`${name} profile`}>
    <img
      src={image}
      alt={`${name} – ${designation}`}
      className="team-member-image"
      loading="lazy"
    />

    <div className="team-member-details">
      <h3 className="team-member-name">{name}</h3>
      <p className="team-member-designation">{designation}</p>

      {linkedin && (
        <a
          href={linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} LinkedIn`}
          className="team-member-linkedin"
        >
          <FaLinkedin />
        </a>
      )}
    </div>
  </article>
);

/* =========================
   Team Section
========================= */
const Team = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const teamMembers = [
    { name: "Arjun Dutta", designation: "Founder & CEO", image: member01, linkedin: "#" },
    { name: "NG Dutta", designation: "Co-Founder & Treasurer", image: member2, linkedin: "#" },
    { name: "Madhumita Sarkar", designation: "Operations", image: member3, linkedin: "#" },
    { name: "Rahul Singh", designation: "Advisor", image: member4, linkedin: "#" },
    { name: "Hasibur Rahaman", designation: "C&M Tech Head", image: member5, linkedin: "#" },
    { name: "Subhabrata Pathak", designation: "Hardware Advisor", image: member6, linkedin: "#" },
    { name: "Abhilekh Verma", designation: "Advisor", image: member7, linkedin: "#" },
    { name: "Viswajeet Kumar", designation: "Advisor", image: member8, linkedin: "#" },
    { name: "Ankur Bhattacharjee", designation: "Advisor", image: member9, linkedin: "#" },
    { name: "Zafrin Sen", designation: "Product Manager", image: images, linkedin: "#" },
    { name: "Mallik Kafur", designation: "Founder's Office", image: images, linkedin: "#" },
    { name: "Shyamali Sarkar", designation: "Healthcare Product Head", image: images, linkedin: "#" },
    { name: "Ankita Dutta", designation: "Wellness & Clinical Head", image: images, linkedin: "#" },
    //{ name: "Aisha Khatun", designation: "Agriculture & Livelihood Admin", image: images, linkedin: "#" },
    //{ name: "Shreya Palit", designation: "Admin", image: images, linkedin: "#" },
    //{ name: "Pritha Karmakar", designation: "Office Support Executive", image: images, linkedin: "#" },
  ];

  return (
    <section className="team-section">
      <header className="section-title">
        <h1 className="section-heading">Our Core Team</h1>
        <h5 className="section-subheading">The People Who Made It Possible</h5>
      </header>

      <div className="slider-container">
        <Slider {...settings}>
          {teamMembers.map((member, idx) => (
            <div key={idx} className="team-member-slide">
              <TeamMember {...member} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Team;
